import React from 'react';
import { FormattedMessage } from 'react-intl';
import { demoUrl } from '../../app/AppHelpers';
import './intro.css';

export const Intro = () => {
    return (
        <div className="introPanel">
            <div className="introWrapper">
                <h2>
                    <FormattedMessage id="Intro.headerTitle" defaultMessage="Better financial health" />
                </h2>
                <p><FormattedMessage id="Intro.text" /></p>
                <a href={demoUrl} target='_blank'><button><FormattedMessage id="Intro.button" /></button></a>
            </div>
            <div className="hashtags"><span>#behavioral economics</span><span> #nudge</span> <span>#long term investing</span> <span>#chatbot</span><span>#Artificial Intelligence</span><span>#gamification</span><span>#B2B</span></div>
        </div>);
};


// WEBPACK FOOTER //
// ./src/containers/intro/Intro.js